require('../../modules/es.object.assign');

module.exports = require('../../internals/path').Object.assign;



//////////////////
// WEBPACK FOOTER
// ./~/@firebase/polyfill/~/core-js/es/object/assign.js
// module id = 235
// module chunks = 1